import React, { useEffect } from 'react';
import Button from '@mui/material/Button';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Dialog from '@mui/material/Dialog';
import { DialogActions, DialogContent, Grid } from '@mui/material';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import Select from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';

export default function VatSelectorDialog(props) {
    const open = props.open;
    const confirm = props.confirm;
    const cancel = props.cancel;
    const vatInfos = props.vatInfos;
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));
    const { t } = useTranslation();

    const [vatHandling, setVatHandling] = React.useState('KOMY');
    const [vatRates, setVatRates] = React.useState([]);
    const [vatRate, setVatRate] = React.useState('');
    const [okToSave, setOkToSave] = React.useState(false);

    useEffect(() => {
        if (vatInfos && vatInfos.length > 0) {
            const vat24 = vatInfos.find((i) => i.vatCode === 'KOMY');
            if (vat24) {
                setVatRates(vat24.allowedVatPercentages);
            }
        }
    }, [vatInfos]);

    const vatHandlingChange = (evt) => {
        const vatCode = evt.target.value;
        setVatHandling(vatCode);
        const vatItem = vatInfos.find((i) => i.vatCode === vatCode);
        if (vatItem) {
            setVatRates(vatItem.allowedVatPercentages);
            setOkToSave(false);
            setVatRate('');
        }
    };

    const vatRateChange = (evt) => {
        const rate = evt.target.value;
        const vatItem = vatInfos.find((i) => i.vatCode === vatHandling);
        if (vatItem && vatItem.allowedVatPercentages.includes(rate)) {
            setVatRate(rate);
            setOkToSave(true);
        }
    };

    if (open)
        return (
            <Dialog
                onClose={cancel}
                aria-labelledby="simple-dialog-title"
                open={open}
                fullWidth={true}
                maxWidth={'md'}
                fullScreen={fullScreen}>
                <DialogContent dividers>
                    <Grid container>
                        <Grid item xs={12} sx={{ pt: '1em', pb: '1em' }}>
                            {t('invoice.setVatRateForRows')}
                        </Grid>

                        <Grid item xs={6}>
                            <InputLabel id="vat-handling-label">{t('invoice.vatHandling')}</InputLabel>

                            <Select
                                required
                                labelId="vat-handling-label"
                                id="vatHandling"
                                name="vatHandling"
                                value={vatHandling}
                                onChange={vatHandlingChange}>
                                {vatInfos.map((opt) => (
                                    <MenuItem key={opt.vatCode} value={opt.vatCode}>
                                        {t('invoice.vatHandlingOpt.' + opt.vatId)}
                                    </MenuItem>
                                ))}
                            </Select>
                        </Grid>
                        <Grid item xs={6}>
                            <InputLabel id="vat-rates-label">{t('invoice.vatPercentage')}</InputLabel>
                            <Select
                                required
                                labelId="vat-rates-label"
                                id="vatRates"
                                name="vatRates"
                                value={vatRate}
                                onChange={vatRateChange}>
                                {vatRates.map((opt) => (
                                    <MenuItem key={opt} value={opt}>
                                        {opt} %
                                    </MenuItem>
                                ))}
                            </Select>
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button
                        variant="contained"
                        color="primary"
                        name="btn-modal-confirm"
                        onClick={() => {
                            confirm(vatHandling, vatRate);
                        }}
                        disabled={!okToSave}>
                        {t('buttons.update')}
                    </Button>
                    &nbsp;&nbsp;
                    <Button
                        variant="contained"
                        sx={{ bgcolor: 'grey.300', color: 'text.primary', '&:hover': { bgcolor: 'grey.400' } }}
                        name="btn-modal-cancel"
                        onClick={cancel}>
                        {t('buttons.cancel')}
                    </Button>
                </DialogActions>
            </Dialog>
        );
    return null;
}

VatSelectorDialog.propTypes = {
    open: PropTypes.bool.isRequired,
    confirm: PropTypes.func.isRequired,
    cancel: PropTypes.func.isRequired,
    vatInfos: PropTypes.array.isRequired,
};
